import * as React from 'react';
import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { BlockHeader } from '../../components/BlockHeader';
import { ContentWrapper } from '../../components/ContentWrapper';
import { LandingBlock } from '../../components/LandingBlock';
import { StepsSmall } from '../StepsSmall';
import { Video } from '../Video';
import { trackVideoBlockShow } from './tracking';

export const MortgageVideo = () => {
  return (
    <ElementInViewport onVisibleFirst={trackVideoBlockShow}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Как работает Циан.Ипотека?</BlockHeader>
          <Video
            videoSrc="https://storage-cdn.cian.site/images/static/mortgage-video/video.mp4"
            posterSrc="https://storage-cdn.cian.site/images/static/mortgage-video/poster.png"
          />
          <StepsSmall />
        </ContentWrapper>
      </LandingBlock>
    </ElementInViewport>
  );
};
